<template>
    <div class="workview">
        <ServiceView  :user-wishes="userWishes"></ServiceView>
        <WorkStatisticUser :wish-period="wishPeriod"
                          :user-data="userData">
        </WorkStatisticUser>
        <v-row v-if="pdfUrl != null">
            <li>
                <a :href="pdfUrl" target="_blank" download>Download {{ pdfName }}</a>
            </li>
        </v-row>
        <v-row>
            <div id="container">
            </div>
        </v-row>
        <v-row v-if="pdfUrl != null">
            <iframe :src="pdfUrl" width="100%" height="800px"></iframe>
        </v-row>
        <v-row v-else>
            <a>Die PDF-Datei wurde nicht gefunden</a>
        </v-row>
    </div>
</template>
  
<script lang="ts">
    import {computed, defineComponent, ref, watch} from "vue"
    import { store } from "@/store"
    import axios from "axios"
    import { GetEmployServiceDataDate } from "@/data/employData"
    import type { EmployServiceData } from '@/types/firestore'
    import { convertUtcToGermanLocal} from "@/hooks/utils"
    import ServiceView from "@/components/ServiceView.vue"
    import WorkStatisticUser from "@/components/WorkStatisticUser.vue"
    
    export default defineComponent({
        components: { ServiceView, WorkStatisticUser },
        name: "WorkView",
        setup(props) {
            const wishPeriod = computed(() => props.wishPeriod);
            const userData = computed(() => props.userData);
            const userWishes = ref<EmployServiceData[]>([])
            const wdpFiles = ref( {url: null, name: null})
            const pdfName = computed(() => {
                console.log("PDF Name: ", wdpFiles.value?.name || "NEIN")
                return wdpFiles.value?.name || null
            })
            const pdfUrl = computed(() => {
                console.log("PDF URL: ", wdpFiles.value?.url || "NEIN")
                return wdpFiles.value?.url || null
            })

            // Warten auf das Vorhandensein von wishPeriod und userData
            watch([wishPeriod, userData], async ([newWishPeriod, newUserData]) => {
                console.log("ENV-User: ", store.getters.firebase_function)
                console.log("Watcher-User aufgerufen: ", newWishPeriod, newUserData)
                userWishes.value = []
                if (!newWishPeriod || !newUserData?.EmployData?.emplno) {
                    return;
                }
                console.log("Daten-User geladen, rufe fetchFilteredFiles auf...");
                wdpFiles.value = await fetchFilteredFiles({
                    periodid: newWishPeriod.id,
                    employid: newUserData.EmployData?.emplno,
                })
                const _datefrom = convertUtcToGermanLocal(newWishPeriod.startDate)
                const _dateto = convertUtcToGermanLocal(newWishPeriod.endDate)
                userWishes.value = await GetEmployServiceDataDate(newUserData.EmployData.emplno, _datefrom, _dateto)
            }, { immediate: true }); // Führt den Watcher sofort beim ersten Mal aus
          
            async function fetchFilteredFiles(filters) {
                console.log("Fetching Files with Filters: ", filters)
                try {
                    if (!filters.periodid || !filters.employid) {
                        return {url: null, name: null}
                    }

                    const response = await axios.get(`${store.getters.firebase_function}/getWDPWishFile`, {
                        params: filters, // Filter an die Cloud Function senden
                    })
                    const data = response.data
                    console.log("Fetched Files: ", data)
                    if (data?.url) {
                        return data
                    }
                    return {url: null, name: null}
                } catch (error) {
                    console.error("Fehler beim Laden der Dateien:", error)
                    return {url: null, name: null}
                }
            }
            return {
                wishPeriod, 
                wdpFiles, 
                pdfName, 
                pdfUrl,
                userWishes,
                fetchFilteredFiles,
            }
        },
        props: {
            wishPeriod: {
                type: Object,
                default: null,
            },
            userData: {
                type: Object,
                default: {},
            },
        },
        emits: ['dayclick'],
        methods: {
            dayClick(date) {
                this.$emit('dayclick', date);
            }
        }
    })
</script>
<style scoped>
.workwiew {
    padding: 50px, 0px, 50px, 0px;
}
</style>